import { EMediaType } from '../../types';
import { RutubePlayer } from '../RutubePlayer';
import { VkPlayer } from '../VkPlayer';
import { YoutubePlayer } from '../YoutubePlayer';

export const MAP_TYPE_TO_PLAYERS = {
  [EMediaType.Video]: YoutubePlayer,
  [EMediaType.VideoVk]: VkPlayer,
  [EMediaType.VideoRutube]: RutubePlayer,
};
